import React from 'react';
import { Button } from 'react-bootstrap';
import './Publishing.css'
const Publishing = () => {
    return (
        <div className='publishing-caption'>

            <div className="item">
            <h3>Change your Programming thought</h3>
                <p>"Any fool can write code that a computer can understand. Good programmers write code that humans can understand."</p>
                <p>~ Martin Fowler</p>
            </div>
        </div>
    );
};

export default Publishing;